import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../utilities/LogErrors'
import { useLanguage } from './../../../utilities/LanguageContext'

//Componentes comunes generales
import { ProgressBar } from './../../Common/ProgressBar'

//Funciones personalizadas del proyecto
import { SaveInstrumentToShow, GetEvaluationMethod } from './../../../utilities/BL/Navigation'
import { UpdateQuickAccessOfCourse } from './../../../utilities/BL/Student/Instruments'
import { ValidateNumberOfExamsTaken } from './../../../utilities/BL/Student/Courses'

//import { Item } from './../Item'
import { Item } from './Item'
import { DeleteSessionInfo, Logout } from './../../../utilities/BL/Sessions'
import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'


//Agregar multiidioma


const Blocks = ({ blocks, session, setSession, quickaccessName, progressByBlockLookup = null, isInstructor = false }) => {
    const { translate } = useLanguage() // Obtén la función de traducción desde el contexto
    const navigate = useNavigate()
    const { showMessage } = useFloatMessage()

    // Estado para manejar qué bloques están activos
    const [activeBlocks, setActiveBlocks] = useState({})
    // Estado para manejar qué objetivos están visibles
    const [showObjectives, setShowObjectives] = useState({})
    // Referencias para cada bloque
    const blockRefs = useRef([])
    //Estado para rastrear el bloque seleccionado
    const [blockToScroll, setBlockToScroll] = useState(null)
    // Referencias para cada tema
    const topicRefs = useRef({})

    const evaluationMethods = {
        DESKTOP: 1,
        THEORIST: 2,
        WEBAPPS: 3
    }

    /**
     * Sincroniza el primer bloque al cargar si `quickaccessName` está definido
     */
    useEffect(() => {
        if (quickaccessName === undefined) {
            setActiveBlocks({ 0: true }) // Establece el primer bloque como activo
        }
    }, [quickaccessName])

    /**
     * Desplazar la ventana al bloque abierto
     */
    useEffect(() => {
        if (!isInstructor) {
            if (blockToScroll !== null && blockRefs.current[blockToScroll]) {
                blockRefs.current[blockToScroll].scrollIntoView({
                    behavior: 'smooth', // Animación suave
                    block: 'start', // Alinear al inicio del bloque
                })
                setBlockToScroll(null) // Restablecer el estado después del desplazamiento
            }
        }
    }, [blockToScroll]) // Ejecutar cuando se cambia el bloque a desplazar

    /**
     * Función para abrir el bloque
     * @param {integer} index 
     */
    const ToggleList = (index) => {
        // Actualizar el estado para mostrar el bloque actual
        setActiveBlocks(() => ({
            [index]: !activeBlocks[index] // Cambia el estado solo para este bloque
        }))
        //setBlockToScroll(index) // Marcar el bloque que debe desplazarse
        setShowObjectives(() => ({})) // Oculta todos los objetivos
    }

    /**
     * Función para mostrar u ocultar el objetivo del bloque
     * @param {integer} index 
     */
    const ToggleShowObjective = (index) => {
        setShowObjectives((prevState) => ({
            ...prevState,
            [index]: !prevState[index] // Invierte el estado del objetivo actual
        }))
    }

    /**
     * Desplazar la ventana al tema que se había hecho clic antes de pasar a la página Viewer
     */
    useEffect(() => {
        if (!isInstructor) {
            const idInstrument = session?.navigation?.instrument?.id

            if (idInstrument !== undefined && idInstrument !== null) {
                blocks.forEach((block, index) => {
                    if (block.items.some(item => item.id === parseInt(idInstrument))) {
                        setActiveBlocks(prevState => ({
                            ...prevState,
                            [index]: true // Abre solo el bloque que contiene el tema seleccionado
                        }))

                        setTimeout(() => {
                            if (topicRefs.current[idInstrument]) {
                                topicRefs.current[idInstrument].scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start',
                                })
                            }
                        }, 500) // Esperamos 500ms para asegurarnos de que el bloque ya está visible    
                    }
                })
            }
        }
    }, [blocks])

    const GoToInstrument = async (item) => {
        try {
            let nextStep = false
            let completeURL = ''
            let isExternalMethod = false


            if (item.type === 1) { //Exam   
                const responseTakeExam = await ValidateNumberOfExamsTaken(item)

                if (responseTakeExam.success) {
                    if (responseTakeExam?.data?.allowTakeExam) {
                        //nextStep = true

                        const responseEvaluationMethod = await GetEvaluationMethod(item)

                        if (responseEvaluationMethod.success) {
                            const method = responseEvaluationMethod?.data?.method

                            if (method === evaluationMethods.THEORIST || method === evaluationMethods.WEBAPPS) {
                                isExternalMethod = true

                                const urlToSend = responseEvaluationMethod?.data?.url

                                if (!urlToSend) {
                                    //console.log('No fue posible enviar al examen solicitado') 
                                    showMessage({
                                        type: MESSAGE_TYPE.BAD,
                                        text: 'No ha sido posible iniciar la evaluación solicitada. Inténtalo nuevamente o inténtalo más tarde'
                                    })
                                    return
                                }

                                if (urlToSend === '') {
                                    //console.log('No fue posible enviar al examen solicitado')
                                    showMessage({
                                        type: MESSAGE_TYPE.BAD,
                                        text: 'No ha sido posible iniciar la evaluación solicitada. Inténtalo nuevamente o inténtalo más tarde'
                                    })
                                    return
                                }

                                //completeURL = `https://eval.ztudia.com/${urlToSend}`
                                
                                completeURL = urlToSend
                                
                                //isExternalMethod = true

                                //window.location.href = completeURL
                                //return
                                // } else {
                                //     navigate('/viewer')
                            } else if (method === evaluationMethods.DESKTOP) {
                                isExternalMethod = false
                                nextStep = true

                            } else {
                                //isExternalMethod = false
                                showMessage({
                                    type: MESSAGE_TYPE.BAD,
                                    text: 'No ha sido posible obtener la evaluación deseada. Inténtalo nuevamente o inténtalo más tarde'
                                })
                                return
                            }
                        } else {
                            //console.log('No fue posible obtener el examen solicitado')
                            showMessage({
                                type: MESSAGE_TYPE.BAD,
                                text: 'No ha sido posible obtener la evaluación solicitada. Inténtalo nuevamente o inténtalo más tarde'
                            })
                            return
                        }
                    } else {
                        // Mostrar modal o mensaje indicando que no puede presentar la evaluación diagnóstica
                        //console.log('Ya has presentado tu examen de Evaluación diagnóstica.')
                        showMessage({
                            type: MESSAGE_TYPE.BAD,
                            text: 'No ha sido posible iniciar tu Evaluación Diagnóstica porque ya la has presentado'
                        })
                        return
                    }
                } else {
                    showMessage({
                        type: MESSAGE_TYPE.BAD,
                        text: 'No ha sido posible cargar tu evaluación. Inténtalo nuevamente o inténtalo más tarde'
                    })
                    return
                }
            } else {
                nextStep = true
            }
            
            if (isExternalMethod) {
                // const responseLogout = await Logout()

                // if (responseLogout.success) {

                // En vez de cerrar la sesión con el Token, cierro la sesión borrando los datos correspondientes del sessionStorage
                // Así detectará que no hay info y lo enviará al Login para iniciar sesión
                await DeleteSessionInfo()
                
                window.location.href = completeURL

                return

                // } else {
                //     // Aunque no se le haya podido cerrar la sesión, lo envíamos a la web ya que como tal, no está mal o no es un error crítico
                //     window.location.href = completeURL
                //     return
                // }
            } else {
                if (nextStep) {
                    const response = await SaveInstrumentToShow(session, item)

                    if (response.success) {
                        const subresponse = await UpdateQuickAccessOfCourse(response.data, item) //instrument.id

                        if (subresponse.success) { setSession(subresponse.data) }

                        navigate('/viewer')
                    } else {
                        // Mostrar mensaje de que no se pudo obtener la info o el error
                        //console.log('No se pudo obtener la info') // Mensaje temporal
                        showMessage({
                            type: MESSAGE_TYPE.BAD,
                            text: 'No ha sido posible obtener la información de la evaluación. Inténtalo nuevamente o inténtalo más tarde'
                        })
                        return
                    }
                }
            }
        } catch (error) {
            await LogErrors('GoToInstrument - Blocks', error)
        }
    }

    const getBlockProgress = (blockId) => {
        // Las claves del lookup son string; normalizamos
        return progressByBlockLookup?.[String(blockId)] ?? null
    }


    return (
        <>
            {blocks !== undefined && blocks.length > 0 && (
                blocks.map((block, index) => {
                    const bp = getBlockProgress(block.id)

                    // let percentage = bp ? bp?.percentageApproved ?? 0 : null
                    // let approvedCount = bp ? bp?.approvedCount ?? 0 : null
                    // let totalItem = bp ? bp?.totalItem ?? (block.items?.length ?? 0) : null

                    let percentage
                    let approvedCount
                    let totalItem

                    if (bp) {
                        if (bp.percentageApproved === undefined || bp.percentageApproved === null) {
                            percentage = null
                        }

                        if (bp.approvedCount === undefined || bp.approvedCount === null) {
                            approvedCount = null
                        }

                        if (bp.totalItem === undefined || bp.totalItem === null) {
                            totalItem = null
                        }

                        percentage = bp.percentageApproved
                        approvedCount = bp.approvedCount
                        totalItem = bp.totalItem // fallback ?? (block.items?.length ?? 0)    
                    } else {
                        percentage = null
                        approvedCount = null
                        totalItem = null
                    }

                    return (
                        <div key={index} ref={(el) => (blockRefs.current[index] = el)} className={`Blocks ${activeBlocks[index] ? 'Blocks-Show' : ''}`} onDoubleClick={() => ToggleList(index)}>
                            <div className="Block">
                                <div className="Block-Info">
                                    <p className="Block-Title">{block.name}</p>

                                    {/* Avance por bloque */}
                                    {(block?.items[0]?.type === 2 && percentage !== null && approvedCount !== null && totalItem !== null) ? (
                                        <>
                                            <ProgressBar percentageCompleted={percentage} />
                                            <span className="Block__Completed">
                                                Aprobado: {approvedCount} de {totalItem} ({percentage}%)
                                            </span>
                                        </>
                                    ) : null}
                                </div>

                                {/* Botón para mostrar/ocultar bloque */}
                                <div className="Block-Buttons">
                                    <button type="button" className="Block-Buttons-List" onClick={() => ToggleList(index)}>
                                        <i className={`bi bi-caret-${activeBlocks[index] ? 'up' : 'down'}-fill`}></i>
                                    </button>
                                </div>
                            </div>

                            <ul className={`Topics ${activeBlocks[index] ? 'Topics-Show' : ''}`}>
                                {/* Botón para mostrar/ocultar el objetivo */}
                                <button type="button" className="Topics-Buttons-Objective" onClick={() => ToggleShowObjective(index)} >
                                    {showObjectives[index] ? translate('labels.course.blocks.hideTopicObjective') : translate('labels.course.blocks.showTopicObjective')}
                                </button>

                                {/* Cuadro del contenido del objetivo */}
                                <div className={`Topics-Objective ${showObjectives[index] ? 'Topics-Objective-Show' : ''}`}>
                                    <button className="Topics-Objective-Close" onClick={() => ToggleShowObjective(index)} ><i className="bi bi-x-lg"></i></button>

                                    <p>{translate('labels.course.blocks.topicObjective')}</p>
                                    <p>{block.objective}</p>
                                </div>

                                {/* Listado de temas con flags de aprobado/visto */}
                                {block.items.map((item, subIndex) => {
                                    const isApproved = bp ? bp?.approvedSet?.has(item.id) ?? false : null
                                    const isViewed = bp ? bp?.viewedSet?.has(item.id) ?? false : null

                                    return (
                                        <Item key={subIndex} item={item} topicRefs={topicRefs} goToInstrument={GoToInstrument} isApproved={isApproved} isViewed={isViewed} />
                                    )
                                })}
                            </ul>
                        </div>
                    )
                })
            )}
        </>
    )
}

export { Blocks };